function CareerServicesCurriculumRightCardNew({ duration, topiclist, list }) {
  return (
    <div className="col-12 topic-details card-wrapper-outer">
      <div className="d-flex justify-content-between align-items-center">
        <p style={{fontSize: '16px' }} className="title">Topic</p>
        <div className="sub-title d-flex align-items-end">
          <p style={{fontSize: '14px' }}>Duration:&nbsp;</p>
          <p>{duration} Hours</p>
        </div>
      </div>
      <div className="border-outline w-100 my-1 my-md-4"></div>
      <div className="test">
      <ul className=" text-left custom-scroll mt-2 mt-md-0">
      {topiclist?.map((item, index) => (
    <div key={index}><br/>
      <h4 style={{ color: "#ffe600",fontSize: '14px' }}>{item}</h4>
      <ul>
        {list[index]?.map((subItem, subIndex) => (
          <li key={subIndex}>{subItem}</li>
        ))}
      </ul>
    </div>
  ))}
      </ul>
      </div>
    </div>
  );
}
export default CareerServicesCurriculumRightCardNew;
